export const Logo = () => {
    return (<div className="logo h-8 w-8">
        <img src="/images/Logo.svg" alt="Small Logo"/>
    </div>);
}